//合同执行情况
import request from '@/plugins/axios'

// 合同执行情况-查询
export function queryPageForExecuteApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForExecute',
        method: 'post',
        data
    })
}
// 合同执行情况-获取执行统计数据
export function getExecuteStatisticsDataApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/getExecuteStatisticsData',
        method: 'post',
        data
    })
}

// 合同执行情况-合同列表（已签约）-可查询
export function queryListJsonSignApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/listJsonSign',
        method: 'post',
        data
    })
}
// 合同执行情况-导出
export function exportForExecuteApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/exportForExecute',
        method: 'post',
        responseType:'blob',
        data
    })
}